import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as HorsesShareActions from '../actions/horses-share.actions';
import * as HorsesShareSelctors from '../selectors/horses-share.selectors';
import * as HorsesShareReducers from '../reducers/horses-share.reducer';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import {
  AdminShareHorseData,
  BatchShareHorsesData,
  HorseShare,
  CreateHorseShareData,
  HorseShareUpdate,
  HorseShareActionResponseTypeEnum,
} from '@sleipai/sleip-models';

@Injectable()
export class HorsesShareStoreFacade {
  constructor(private readonly store: Store<HorsesShareReducers.State>) {}

  isHorseShareEntityLoaded$ = (groupId: string, horseId: string) =>
    this.store.pipe(
      select(HorsesShareSelctors.selectHorsesShareItem(groupId, horseId)),
      map((horseShareItem: HorseShare | null) => horseShareItem !== null)
    );

  getHorseShareEntity$ = (groupId: string, horseId: string) =>
    this.store.pipe(
      select(HorsesShareSelctors.selectHorsesShareItem(groupId, horseId))
    );

  getIsLoading$: Observable<boolean> = this.store.pipe(
    select(HorsesShareSelctors.selectIsLoading)
  );

  getHorseShareSaved$: Observable<boolean> = this.store.pipe(
    select(HorsesShareSelctors.selectHorsesShareSaved)
  );

  getHorseShareError$: Observable<string | null> = this.store.pipe(
    select(HorsesShareSelctors.selectHorsesShareError)
  );

  getHorseShareActionResponseType$: Observable<HorseShareActionResponseTypeEnum | null> =
    this.store.pipe(
      select(HorsesShareSelctors.selectHorseShareActionResponseType)
    );

  fetchHorseShareItem$ = (groupId: string, horseId: string, userId?: string) =>
    this.store.dispatch(
      HorsesShareActions.loadHorseShareInfo({ groupId, horseId, userId })
    );

  createHorseShare$ = (data: CreateHorseShareData) =>
    this.store.dispatch(HorsesShareActions.saveHorseShareInfo({ data }));

  // admin dashboard only
  adminCreateHorseShare$ = (data: AdminShareHorseData) =>
    this.store.dispatch(HorsesShareActions.adminSaveHorseShareInfo({ data }));

  batchShareHorses$ = (data: BatchShareHorsesData) =>
    this.store.dispatch(HorsesShareActions.batchShareHorses({ data }));

  stopHorseShare$ = (data: HorseShareUpdate) =>
    this.store.dispatch(HorsesShareActions.stopHorseShare({ data }));

  reactivateHorseShare$ = (data: HorseShareUpdate) =>
    this.store.dispatch(HorsesShareActions.reactivateHorseShare({ data }));
}
